import { connect } from 'react-redux';

import {
  getOfficeDetails,
  getOfficesShortList,
} from '../../OfficesNew/officesActions';
import {
  getOrganizationMembersList,
  getOrganizationMembersShortList,
} from '../../Projects/projectsActions';
// Actions
import {
  clearTimesheetList,
  getDailyTimesheets,
  getOtherTimesheets,
} from '../timesheetActions';
// Component
import TimesheetCustomRange from './TimesheetCustomRange';

// Store props to map with current state
const mapStateToProps = state => ({
  isLoading: state.timesheet.isLoading,
  dailyTimesheetLoading: state.timesheet.dailyTimesheetLoading,

  dailyTimesheets: state.timesheet.dailyList,
  timesheetsList: state.timesheet.list,

  selectedOrganization: state.organization.selectedOrganization,
  profileData: state.profile.profileData,

  //member short list
  orgMembersShortList: state.project.orgMembersShortList,
  memberShortListIsLoading: state.project.memberShortListIsLoading,
  //office
  officesShortList: state.office.officesShortList,
  officeDetails: state.office.officeDetails,
  filters: state.filterReducer.filters,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getOrganizationMembersList: details =>
    dispatch(getOrganizationMembersList({ ...details })),
  getDailyTimesheets: payload => dispatch(getDailyTimesheets(payload)),
  getOtherTimesheets: payload => dispatch(getOtherTimesheets(payload)),
  clearTimesheetList: () => dispatch(clearTimesheetList()),
  getOrganizationMembersShortList: params =>
    dispatch(getOrganizationMembersShortList(params)),
  getOfficeDetails: payload => dispatch(getOfficeDetails(payload)),
});

// connect states and dispatchers with components
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TimesheetCustomRange);
